var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "39", height: "38", viewBox: "0 0 39 38", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("rect", { id: "path-2", width: "38", height: "38", rx: "4" })
    ),
    React.createElement(
      "g",
      { transform: "translate(.91)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "mask-3", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#path-2" })
      ),
      React.createElement("path", { d: "M25.271 27.506l-1.18-6.881 5-4.874-6.91-1.004-3.09-6.261-3.09 6.26-6.91 1.005 5 4.874-1.18 6.881 6.18-3.249 6.18 3.25z", stroke: "#FFF", strokeWidth: "2.2", mask: "url(#mask-3)" })
    )
  );
});